import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";

import Landing from "./pages/Landing";
import RespondentRegister from "./pages/RespondentRegister";
import RespondentLogin from "./pages/RespondentLogin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Consent from "./pages/Consent";
import VoiceCapture from "./pages/VoiceCapture";
import VoiceIntro from "./pages/VoiceIntro";
import Questionnaires from "./pages/Questionnaires";
import InstrumentDeepLink from "./pages/InstrumentDeepLink";
import Results from "./pages/Results";
import RespondentInsights from "./pages/RespondentInsights";
import RespondentMocaVoice from "./pages/RespondentMocaVoice";
import MocaShareView from "./pages/MocaShareView";
import DoctorLogin from "./pages/DoctorLogin";
import DoctorDashboard from "./pages/DoctorDashboard";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AuthCallback from "./pages/AuthCallback";
import ClinicianDashboard from "./pages/ClinicianDashboard";
import ClinicianCaseDetail from "./pages/ClinicianCaseDetail";
import ClinicianBlindedReview from "./pages/ClinicianBlindedReview";

function AppRouter() {
  const location = useLocation();
  // Emergent OAuth returns with session_id in URL fragment — process first
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/register" element={<RespondentRegister />} />
      <Route path="/login" element={<RespondentLogin />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/consent" element={<Consent />} />
      <Route path="/voice" element={<VoiceCapture />} />
      <Route path="/voice-intro" element={<VoiceIntro />} />
      <Route path="/questionnaires" element={<Questionnaires />} />
      <Route path="/q/:instrumentId" element={<InstrumentDeepLink />} />
      <Route path="/results" element={<Results />} />
      <Route path="/insights" element={<RespondentInsights />} />
      <Route path="/moca-voice" element={<RespondentMocaVoice />} />
      <Route path="/share/moca-voice/:token" element={<MocaShareView />} />
      <Route path="/doctor/login" element={<DoctorLogin />} />
      <Route path="/doctor" element={<DoctorDashboard />} />
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin" element={<AdminDashboard />} />
      <Route path="/clinician" element={<ClinicianDashboard />} />
      <Route path="/clinician/blinded" element={<ClinicianBlindedReview />} />
      <Route path="/clinician/cases/:case_id" element={<ClinicianCaseDetail />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster richColors closeButton position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
